import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=1f58b32f&scoped=true"
import script from "./Owner.vue?vue&type=script&lang=js"
export * from "./Owner.vue?vue&type=script&lang=js"
import style0 from "./Owner.vue?vue&type=style&index=0&id=1f58b32f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f58b32f",
  null
  
)

export default component.exports